import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import bemClass from './../../../utils/bemClass'

import './MenuIcon.css'

const cn = bemClass('MenuIcon')

class MenuIcon extends PureComponent {
    state = { active: false }

    render() {
        const { className, active, onClick } = this.props

        return (
            <div className={`${cn({ active })} ${className}`} onClick={onClick}>
                {[1,2,3].map(
                    key =>
                        <div key={key} className={cn('line', { key, active })} />
                )}
            </div>
        )
    }
}

MenuIcon.propTypes = {
    className: PropTypes.string,
    active: PropTypes.bool,
    onClick: PropTypes.func,
}

MenuIcon.defaultProps = {
    active: false,
    onClick: () => {},
}

export default MenuIcon


// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcon/MenuIcon.jsx